import React from "react";
import { Col, Container, Row } from "reactstrap";
import Section from "./Section";

import Stock from "./Stock";
import Pagination from "./Pagination";

import sailfish from "../../assets/images/fish_types/sailfish.png";
import yellowFinTuna from "../../assets/images/fish_types/yellowfin_tuna.png";
import swordFish from "../../assets/images/fish_types/sword_fish.png";
import bigEyeTuna from "../../assets/images/fish_types/big_eye_tuna.png";

const QualityInspect = () => {
  document.title = "Quality | Quality Inspector | Inspect";

  // Example data to pass as props

  return (
    <React.Fragment>
      <Section />
      <section className="section">
        <Container>
          <Row>
            <Col lg={12}>{/* <CustomCarousel items={carouselItems} /> */}</Col>
            <Col lg={12}></Col>
          </Row>
        </Container>
        <Container>
          <Row>
            {/* <Col lg={12}>
              <Sidebar />
            </Col> */}

            <Col lg={12}>
              <div>
                {/* <JobSearchOptions /> */}
                <Stock />
                <Pagination />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default QualityInspect;
